<template>
    <div class="pc_page" id="pc_page">
        <!-- 活动标题 -->
        <div class="wechat-title" v-wechat-title="'《使魔计划》周年庆典'"></div>
        <div class="title"></div>
        <div class="logo"></div>
        <div class="box">
            <div class="qrcode-box">
                <div id="qrcode" class="qrcode"></div>
            </div>
        </div>
    </div>
</template>
<script>
import { getRandomString } from '@/utils/utils';
export default {
    name: 'anniversary',
    created() {
        var userAgent = navigator.userAgent.toLowerCase();
        var isPC = userAgent.indexOf('windows') > -1 || userAgent.indexOf('macintosh') > -1;
        if (isPC) {
            console.log('当前设备是 PC');
        } else {
            this.$router.push(`enter${getRandomString()}`);
            console.log('当前设备不是 PC');
        }
    },
    mounted() {
    },
    methods: {
    }
}
</script>
<style lang="less">
@import url("./pc.less");
</style>


// WEBPACK FOOTER //
// src/pages/servitor/anniversary/index/pc.vue